import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import darajaLogoBlack from "@/assets/images/darajaLogoBlack.svg";
import MastercardLogo from "@/assets/images/MastercardLogo.svg";

import { useAuth } from "../hooks/useAuth";

const Login: React.FC = () => {
  const { status, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as { from?: { pathname?: string } })?.from?.pathname || "/dashboard";

  const [error, setError] = useState("");

  useEffect(() => {
    if (status === "signedIn") {
      navigate(from, { replace: true });
    }
  }, [status, from, navigate]);

  const handleLogin = async () => {
    setError("");

    try {
      await login();
    } catch (err: any) {
      setError(err?.message || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200">
      <div className="w-full max-w-sm bg-gray-100 border border-gray-300 rounded-xl p-8 text-center">
        {/* Mastercard Logo */}
        <div className="flex justify-center mb-4">
          <img src={MastercardLogo} alt="Mastercard" className="h-10" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">Sign in</h2>

        {/* Selected Option */}
        <div className="border-2 border-[var(--color-brand)] rounded-lg px-4 py-3 flex items-center gap-2 mb-6">
          <div className="h-3 w-3 rounded-full border-2 border-[var(--color-brand)] flex items-center justify-center">
            <div className="h-1.5 w-1.5 bg-[var(--color-brand)] rounded-full" />
          </div>
          <span className="text-gray-700 font-medium">Daraja Frontend</span>
        </div>

        {/* Login Button */}
        <button
          onClick={handleLogin}
          className="w-full bg-[var(--color-brand)] text-white py-2.5 rounded-lg font-semibold transition hover:opacity-90"
        >
          Login
        </button>

        {error ? <div className="text-red-600 text-sm mt-3">{error}</div> : null}

        {/* Divider */}
        <hr className="my-6 border-gray-300" />

        {/* Bottom Logo */}
        <div className="flex justify-center">
          <img src={darajaLogoBlack} alt="Daraja" className="h-8" />
        </div>
      </div>
    </div>
  );
};

const LoginPageWrapper = () => {
  const { status } = useAuth();

  if (status === "signedIn") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Login />;
};

export default LoginPageWrapper;
